import { isFuture } from 'date-fns';
import { useMemo } from 'react';

import { Milestone } from '../../apollo/__generated__/graphql';
import { useCurrentMilestone } from './useCurrentMilestone';

export const useNextMilestone = (milestones: Milestone[]) => {
  const currentMilestone = useCurrentMilestone(milestones);
  return useMemo(() => {
    return (
      milestones.find((milestone) => {
        if (milestone.id === currentMilestone?.id) {
          return false;
        }

        return isFuture(milestone.startAt);
      }) ?? null
    );
  }, [milestones, currentMilestone]);
};
